import { createSelector } from 'reselect'

const isLoadingMore = state => state.producers.readProducers.isLoadingMore
export const isLoadingMoreSelector = createSelector(
	isLoadingMore,
	isLoadingMoreSelector => isLoadingMoreSelector
)

const list = state => state.producers.readProducers.producersData
export const listSelector = createSelector(
	list,
	listSelector => listSelector
)
	
const listIsloading = state => state.producers.readProducers.isLoading
export const listIsloadingSelector = createSelector(
  listIsloading,
  listIsloadingSelector => listIsloadingSelector
)

const loadCompleted = state => state.producers.readProducers.loadCompleted
export const loadCompletedSelector = createSelector(
  loadCompleted,
  loadCompletedSelector => loadCompletedSelector
)